import { render, staticRenderFns } from "./ClientEditor.vue?vue&type=template&id=a391a0be&"
import script from "./ClientEditor.vue?vue&type=script&lang=js&"
export * from "./ClientEditor.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditor.vue?vue&type=style&index=0&id=a391a0be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports